<template>
    <div class="history_detail" style="margin-bottom: 45px;">
        <div class="history_detail_title">
            <p>历史明细查询</p>
            <a
                style="margin-left: 10px;"
                title="低版本IE需手动加上.csv后缀"
                @click="exportHistory"
                >
                <vue-button :loading="exportLoading" type="blue" size="small">导出</vue-button>
            </a>
            <div class="history_day_select">
                <p>持股周期 :</p>
                <select class="day_select" v-model="currentday"  @click="charySelect">
                    <option :value="item" v-for="(item, key, index) in daySelect" :key="key">{{ item }} 天</option>
                </select>
            </div>

            <div class="history_day_select" v-show="transactiontype === '2'">
                <p>择时选项 :</p>
                <select class="day_select" v-model="selectedSignal"  @click="charySelectTow">
                    <option :value="item" v-for="(item, key, index) in marketSignals" :key="key">{{ signalData[item] }}</option>
                </select>
            </div>

            <div class="sd-toolbar_1">
                <div class="sd-toolbar_operabox_1">
                    <input id="history_detail_startDate" type="text" readonly="readonly" class="trade_detail_startDate_1" v-model="tradeStartDate" @click="showTradeDateDialog($event, '#F{$dp.$D(\'history_detail_endDate\')}', minDate)" @blur="startDatePoint">
                    <span class="time-split">&nbsp;至&nbsp;</span>
                    <input id="history_detail_endDate" type="text" readonly="readonly" class="trade_detail_endDate_1" v-model="tradeEndDate" @click="showTradeDateDialog($event, maxDate, '#F{$dp.$D(\'history_detail_startDate\')}')" @blur="endDatePoint">
                </div>
            </div>
        </div>

        <div class="history_detail_main">
            <table cellspacing="0">
                <thead>
                    <th>股票代码</th>
                    <th>股票简称</th>
                    <th>买入时间</th>
                    <th>卖出时间</th>
                    <th>买入价</th>
                    <th>卖出价</th>
                    <th>单次收益率</th>
                </thead>
            </table>
            <EasyScrollbar :barOption="myBarOption">
                <div class="rolltable">
                    <table cellspacing="0">
                        <tbody>
                            <tr v-for="(hist, index) in historyList" :class="(index + 1) % 2 === 0 ? 'gray' : ''">
                                <td width="159">{{ hist.stock_code }}</td>
                                <td
                                    width="159"
                                    class="td-highlight"
                                    @click="codeLink(hist.stock_code)"
                                    @mouseenter="debounceShowQuoteChart($event, hist)"
                                    @mouseleave="hideQuoteChart(hist)"
                                    >{{ hist.stock_name }}</td>
                                <td width="160">{{ hist.start_date }}</td>
                                <td width="160">{{ hist.status === 3 ? '持仓' : hist.end_date }}</td>
                                <td width="120">{{ hist.start_price | safeFloatFixedTwo }}</td>
                                <td width="120">{{ hist.end_price | safeFloatFixedTwo }}</td>
                                <td width="200" :class="hist.profit | riseAndFallClass">{{ hist.profit | safePercentFixedTwo }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </EasyScrollbar>
        </div>
    </div>
</template>

<script>
    /* eslint-disable no-undef */
    /* eslint-disable no-new */
    import axios from 'axios'
    import {showTradeDateDialog} from '@/lib/wDatePicker.js'
    import exportCsv from '@/lib/exportCsv.js'
    import { safePercentFixedTwo } from '@/filters'
    import quoteChart from '@/lib/quoteChartVue.js'
    import { debounce } from 'lodash'
    export default {
        props: {
            strategyId: {
                type: String
            },
            // 回测id
            backtestId: {
                type: String,
                required: true
            },
            // 回测日期最大值
            maxDate: {
                type: String,
                required: true
            },
            // 回测日期最小值
            minDate: {
                type: String,
                required: true
            },
            // 滚动条配置
            myBarOption: {
                type: Object,
                required: true
            },
            // 周期可选值
            daySelect: {
                type: Array,
                required: true
            },
            transactiontype: String,
            maxWinrate: Array,
            signalData: Object,
            refresh: Boolean,
            marketSignals: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        data () {
            var self = this
            var debounceShowQuoteChart = debounce(function () {
                // 鼠标还停留在dom上
                if (arguments[0].target.contains(self.$mousemoveEvent.target)) {
                    self.showQuoteChart(...arguments)
                }
            }, 1000)

            return {
                debounceShowQuoteChart,
                tradeStartDate: '',
                tradeEndDate: '',
                currentday: '',
                selectedSignal: '',
                historyarr: [],
                detailContent: '',
                backtestContent: '',
                exportLoading: false
            }
        },
        computed: {
            historyList () {
                return this.filterHistory(this.historyarr.slice(0, 300))
            },
            detailContentPoint () {
                return this.$buriedPoint.strategyDetails.history
            },
            backtestContentPoint () {
                return this.$buriedPoint.strategyBacktest.history
            }
        },
        methods: {
            hideQuoteChart (item) {
                quoteChart.hide(item.stock_market.toLowerCase() + '_' + item.stock_code)
            },
            showQuoteChart (event, item) {
                var DOMRect = event.srcElement.getBoundingClientRect()
                quoteChart({
                    code: item.stock_market.toLowerCase() + '_' + item.stock_code,
                    top: DOMRect.top,
                    left: DOMRect.right - 30
                })
            },
            filterHistory (arr) {
                var self = this
                return arr.filter(function (item) {
                    return Number(item.start_date) >= self.dateToNumber(self.tradeStartDate) && item.start_date <= self.dateToNumber(self.tradeEndDate)
                })
            },
            getFileName () {
                let date = new Date()
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                month = month < 10 ? '0' + month : month
                let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
                let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
                let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
                let second = date.getUTCSeconds() < 10 ? '0' + date.getUTCSeconds() : date.getUTCSeconds()
                let filename = '' + year + month + day + hour + minute + second
                return filename
            },
            exportHistory () {
                let tableStr = ''
                let titleStr = '股票代码,股票简称,买入时间,卖出时间,买入价,卖出价,单次收益率'
                let filename = this.getFileName()

                let historyList = this.filterHistory(this.historyarr)

                if (this.detailContent) {
                    window.TA.log(this.detailContentPoint.export.replace('_square', '_square_' + this.strategyId))
                } else {
                    window.TA.log(this.backtestContentPoint.export)
                }

                if (this.transactiontype === '1') { // 非择时
                    tableStr = this.currentday + '天\n' + titleStr + '\n' + this.dataToCsvStr(historyList)
                    exportCsv(tableStr, filename)
                } else { // 择时
                    if (this.marketSignals.length === 1) {
                        tableStr = this.currentday + '天,"' + this.signalData[this.selectedSignal] + '"\n' + titleStr + '\n' + this.dataToCsvStr(historyList)
                        exportCsv(tableStr, filename)
                    } else {
                        let requestSignal = this.selectedSignal === this.marketSignals[0] ? this.marketSignals[1] : this.marketSignals[0]
                        var self = this
                        this.exportLoading = true
                        this.requestHistory({
                            id: this.backtestId,
                            start_date: this.tradeStartDate,
                            end_date: this.tradeEndDate,
                            period: Number(this.currentday),
                            menv: requestSignal
                        }).then((res) => {
                            self.exportLoading = false
                            let requestHistory = ''
                            if (res.data.result instanceof Array) {
                                requestHistory = res.data.result
                            } else {
                                requestHistory = []
                            }

                            let dayStr = ''
                            let menvTitleStr = ''
                            self.marketSignals.forEach((item) => {
                                dayStr += self.currentday + '天,"' + self.signalData[item] + '",,,,,,,'
                                menvTitleStr += titleStr + ',,,'
                            })
                            tableStr += dayStr + '\n' + menvTitleStr + '\n' + self.menvDataToCsvStr(historyList, requestHistory, requestSignal)

                            exportCsv(tableStr, filename)
                        }).catch((error) => {
                            self.exportLoading = false
                            self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                        })
                    }
                }
            },
            dataToCsvStr (historyList) {
                let csvStr = ''
                let endDate = ''
                historyList.forEach((item) => {
                    endDate = item.status === 3 ? '持仓' : item.end_date
                    csvStr += '\'' + item.stock_code + ',' + item.stock_name + ',' + item.start_date + ',' + endDate + ',' + item.start_price + ',' + item.end_price + ',' + safePercentFixedTwo(item.profit) + '\n'
                })
                return csvStr
            },
            menvDataToCsvStr (historyList, requestHistory, requestSignal) {
                let csvObj = {}
                let requestLength = requestHistory.length
                let historyLength = historyList.length
                csvObj[this.selectedSignal] = historyList
                csvObj[requestSignal] = requestHistory
                let endDate = ''
                let itemData
                let maxLength = requestLength > historyLength ? requestLength : historyLength
                let tableStr = ''
                for (var i = 0; i < maxLength; i++) {
                    this.marketSignals.forEach((item) => {
                        if (csvObj[item][i] === undefined) {
                            tableStr += ',,,,,,,,,'
                        } else {
                            itemData = csvObj[item][i]
                            endDate = itemData.status === 3 ? '持仓' : itemData.end_date
                            tableStr += '\'' + itemData.stock_code + ',' + itemData.stock_name + ',' + itemData.start_date + ',' + endDate + ',' + itemData.start_price + ',' + itemData.end_price + ',' + safePercentFixedTwo(itemData.profit) + ',,,'
                        }
                    })
                    tableStr += '\n'
                }

                return tableStr
            },
            startDatePoint () {
                if (this.detailContent) {
                    window.TA.log(this.detailContentPoint.startDate.replace('_square', '_square_' + this.strategyId))
                } else {
                    window.TA.log(this.backtestContentPoint.startDate)
                }
            },
            endDatePoint () {
                if (this.detailContent) {
                    window.TA.log(this.detailContentPoint.endDate.replace('_square', '_square_' + this.strategyId))
                } else {
                    window.TA.log(this.backtestContentPoint.endDate)
                }
            },
            charySelect () {
                if (this.detailContent) {
                    window.TA.log(this.detailContentPoint.cycleOption.replace('_square', '_square_' + this.strategyId))
                } else {
                    window.TA.log(this.backtestContentPoint.cycleOption)
                }
            },
            charySelectTow () {
                if (this.detailContent) {
                    window.TA.log(this.detailContentPoint.timingOption.replace('_square', '_square_' + this.strategyId))
                } else {
                    window.TA.log(this.backtestContentPoint.timingOption)
                }
            },
            dateToNumber (date) {
                return Number(date.replace(/-/g, ''))
            },
            showTradeDateDialog,
            gethistorydetail: function () {
                var self = this

                var params = {
                    id: this.backtestId,
                    start_date: this.tradeStartDate,
                    end_date: this.tradeEndDate,
                    period: Number(this.currentday)
                }
                if (this.transactiontype === '2') {
                    params['menv'] = this.selectedSignal
                }
                this.requestHistory(params).then((res) => {
                    if (res.data.result instanceof Array) {
                        self.historyarr = res.data.result
                    } else {
                        self.historyarr = []
                    }
                }).catch((error) => {
                    self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                })
            },
            requestHistory (params) {
                return axios.get('/tradebacktest/historydetail?sort_by=desc', {
                    params: params
                })
            },
            init () {
                if (this.transactiontype === '2') {
                    this.selectedSignal = this.maxWinrate[1]
                    this.currentday = this.maxWinrate[2]
                } else {
                    this.currentday = this.maxWinrate[1]
                }

                this.tradeStartDate = this.minDate
                this.tradeEndDate = this.maxDate
            }
        },
        created () {
            this.init()
        },
        watch: {
            refresh () {
                this.init()
            },
            backtestId () {
                this.gethistorydetail()
                this.init()
            },
            currentday () {
                this.gethistorydetail()
            },
            selectedSignal () {
                this.gethistorydetail()
            },
            period () {
                this.currentday = this.period
            },
            maxDate () {
                this.tradeEndDate = this.maxDate
            },
            minDate () {
                this.tradeStartDate = this.minDate
            }
        },
        mounted () {
            this.detailContent = document.getElementsByClassName('strategydetailmain')[0]
            this.backtestContent = document.getElementsByClassName('strategybacktestmain')[0]
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .td-highlight {
        color: #3e76c2 !important;
        &:hover {
            text-decoration: underline;
            cursor: pointer;
        }
    }
    @import '../../scss/backtest/main.scss';
</style>



// WEBPACK FOOTER //
// src/components/strategybacktest/history.vue